/* tslint:disable */
/* eslint-disable */
/**
 * users
 * users
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { AcknowledgeCurrentUserPylonPendingMessage200ResponseData } from './AcknowledgeCurrentUserPylonPendingMessage200ResponseData';
import {
    AcknowledgeCurrentUserPylonPendingMessage200ResponseDataFromJSON,
    AcknowledgeCurrentUserPylonPendingMessage200ResponseDataFromJSONTyped,
    AcknowledgeCurrentUserPylonPendingMessage200ResponseDataToJSON,
    AcknowledgeCurrentUserPylonPendingMessage200ResponseDataToJSONTyped,
} from './AcknowledgeCurrentUserPylonPendingMessage200ResponseData';

/**
 * 
 * @export
 * @interface AcknowledgeCurrentUserPylonPendingMessage200Response
 */
export interface AcknowledgeCurrentUserPylonPendingMessage200Response {
    /**
     * 
     */
    data: AcknowledgeCurrentUserPylonPendingMessage200ResponseData;
}

/**
 * Check if a given object implements the AcknowledgeCurrentUserPylonPendingMessage200Response interface.
 */
export function instanceOfAcknowledgeCurrentUserPylonPendingMessage200Response(value: object): value is AcknowledgeCurrentUserPylonPendingMessage200Response {
    if (!('data' in value) || value['data'] === undefined) return false;
    return true;
}

export function AcknowledgeCurrentUserPylonPendingMessage200ResponseFromJSON(json: any): AcknowledgeCurrentUserPylonPendingMessage200Response {
    return AcknowledgeCurrentUserPylonPendingMessage200ResponseFromJSONTyped(json, false);
}

export function AcknowledgeCurrentUserPylonPendingMessage200ResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): AcknowledgeCurrentUserPylonPendingMessage200Response {
    if (json == null) {
        return json;
    }
    return {
        
        'data': AcknowledgeCurrentUserPylonPendingMessage200ResponseDataFromJSON(json['data']),
    };
}

export function AcknowledgeCurrentUserPylonPendingMessage200ResponseToJSON(json: any): AcknowledgeCurrentUserPylonPendingMessage200Response {
    return AcknowledgeCurrentUserPylonPendingMessage200ResponseToJSONTyped(json, false);
}

export function AcknowledgeCurrentUserPylonPendingMessage200ResponseToJSONTyped(value?: AcknowledgeCurrentUserPylonPendingMessage200Response | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'data': AcknowledgeCurrentUserPylonPendingMessage200ResponseDataToJSON(value['data']),
    };
}

